// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__89Xoh","newExpiryDate":"styles_newExpiryDate__2yMq5","footer":"styles_footer__3v8kE"};